<template>
	<v-card id="assigned_tree_selection" elevation="0" color="transparent" @click.stop>
		<v-text-field
			style="position: relative"
			:color="color"
			:background-color="bgColor"
			:outlined="outlined"
			:placeholder="placeholder"
			:error="error"
			v-model="search_key"
			dense
			hide-no-data
			hide-details
			rows="1"
			auto-grow
			:readonly="loading"
			:disabled="disabled"
			@click.stop="queryAssigned"
			@input="inviteesQuery" 
		>
			<template v-slot:append>
				<v-icon v-if="assigned_to.length !== 0" small :disabled="disabled" @click="filter(null)">mdi-close</v-icon>
				<div v-if="loading" class="load"></div>
				<v-icon v-else :disabled="disabled" @click.stop="queryAssigned">mdi-menu-down</v-icon>
			</template>
			<template v-slot:prepend-inner>
				<v-row class="ma-0" style="max-height: 64px; overflow-y: auto">
					<div v-for="(item) in assigned_to" :key="item.id">
						<v-chip
							style="margin: 1px"
							:disabled="disabled"
							small
							label
							close
							close-icon="$close"
							@click:close="remove(item)"
						>
							{{ item.name }}
						</v-chip>
					</div>
				</v-row>
			</template>
		</v-text-field>
		<v-card-text v-if="!close_all && is_open && search_key.length === 0" class="pa-0 tree-container tree-wrap" :style="`width: ${maxWidth}px;top: ${top}px;left: ${left}px;`">
			<div class="tree-wrap-container">
				<v-treeview
					v-model="assigned_to"
					:items="assign_items"
					:color="color"
					:selected-color="color"
					:open.sync="open"
					:active="selected"
					selectable
					multiple-active
					activatable
					return-object
					open-on-click
					hoverable
					dense
					expand-icon="mdi-chevron-down"
					@update:active="onTreeviewNoteActive($event)"
				>
					<template v-slot:label="{ item }">
						<v-row class="mx-0 my-1" :align="'center'">
							<span>{{ item.name }}</span>
							<v-tooltip top>
								<template v-slot:activator="{ on, attrs }">
									<v-row v-if="item.kind === true" v-bind="attrs" v-on="on" class="ma-0" :align="'center'">
										<Kind width="16" height="16" :color="'rgba(25, 42, 62, 0.5)'" />
									</v-row>
								</template>
								<span>The selected Kind has been approved for this user’s {{ item.tooltip }}. </span>
							</v-tooltip>
						</v-row>
					</template>
				</v-treeview>
			</div>
		</v-card-text>
		<v-card-text v-if="!close_all && !is_open && search_key.length !== 0" class="pa-0 tree-container tree-wrap" :style="`width: ${maxWidth}px;top: ${top}px;left: ${left}px;`">
			<div class="tree-wrap-container">
				<v-list-item v-for="item in invitees_items" :key="item.id" dense>
					<v-row align-self="center" class="mt-0">
						<v-checkbox
							class="ma-0 pa-0"
							v-model="invitees_to"
							:value="item.id"
							:color="color"
							dense
							hide-details
							@click.stop
							@change="onInviteesToChange($event)"
						>
							<template v-slot:label>
								<span>
									{{ item.name }}
									<v-chip v-if="item.type === freelancer" color="info" x-small class="ml-1">Freelancer</v-chip>
								</span>
							</template>
						</v-checkbox>
					</v-row>
				</v-list-item>
			</div>
		</v-card-text>
	</v-card>
</template>

<script>
import Kind from "@/components/icons/kind.vue";

const ALLEMPLOYEES = 2;
const ROLES = 1;
const DEPARTMENTS = 0;
const FREELANCER = 4;

const Employee_Key = 'Employee';
const Freelancer_key = 'Freelancer';

const AssignTree = [
	{
		id: 2,
		name: 'Employees',
		children: [],
	},
	{
		id: 4,
		name: 'Freelancers',
		children: [],
	},
	{
		id: 1,
		name: 'Roles',
		children: [],
	},
	{
		id: 0,
		name: 'Departments',
		children: [],
	}
];

export default {
	name: 'AssignedTreeSelection',
	props: {
		color: {
			type: String,
			default: '#000000'
		},
		bgColor: {
			type: String,
			default: ''
		},
		outlined: {
			type: Boolean,
			default: true
		},
		placeholder: {
			type: String,
			default: ''
		},
		selected: {
			type: Array,
			default: () => []
		},
		disabled: {
			type: Boolean,
			default: false
		},
		closeSelection: {
			type: Number,
			default: 0
		},
		kinds: {
			type: Array,
			default: () => []
		},
		error: {
			type: Boolean,
			default: false
		}
	},
	components: {
		Kind
	},
	data() {
		this.freelancer = FREELANCER;

		return { 
			loading: false,
			is_open: false,
			close_all: false,
			assign_items: AssignTree,
			assign_items_origin: AssignTree,
			assigned_to: this.selected,
			invitees: [],
			invitees_items: [],
			invitees_to: this.selected.map(s => { return s.id }),
			open: [],

			search_key: '',

			maxWidth: 0,
			top: 0,
			left: 0
		}
	},
	watch: {
		closeSelection() {
			this.close_all = true;
			this.search_key = '';

			this.is_open = false;
		},
		assigned_to() {
			if (this.assigned_to.length !== 0) {
				const assigned_to_key = (this.assigned_to.map(a => {return a.id })).join();
				const selected_key = (this.selected.map(a => {return a.id })).join();

				if (assigned_to_key !== selected_key) {
					this.$emit('assign-selected', this.assigned_to);
				}
			} else {
				this.$emit('assign-selected', this.assigned_to);
			}
		},
		selected() {
			this.assigned_to = this.selected;
			this.invitees_to = this.selected.map(s => { return s.id });
		}
	},
	methods: {
		async inviteesQuery(key) {
			if (key.length === 0) return;

			this.is_open = false;
			this.close_all = false;
			this.invitees_items = [];
			const search_key = key.toLowerCase();

			this.invitees.forEach(invitee => {
				const name_lower_case = invitee.name.toLowerCase();
				
				if (name_lower_case.includes(search_key)) {
					this.invitees_items.push(invitee);
				}
			});
		},
		async queryAssigned() {
			if (this.disabled === true) return;

			const elem = document.getElementById("assigned_tree_selection");
			const diff_bottom = this.$vuetify.breakpoint.height - elem.getBoundingClientRect().bottom;

			this.maxWidth = elem.clientWidth;

			this.top = diff_bottom >= 240 ? elem.getBoundingClientRect().bottom : (elem.getBoundingClientRect().top - 240);
			this.left = elem.getBoundingClientRect().left;

			await this.getAssignees();
		},
		async getAssignees() {
			this.loading = true;
			let url = '/api/tasks/list_assignees';

			const params = [];
			// 3 = "Employees", 12 = 'Freelancers', from 'api/addressbook/meta'
			params.push("abook_types=" + encodeURIComponent("3, 12"));
			if (this.kinds && this.kinds.length !==0 ) {
				const kind_ids = this.kinds.map(k => { return k.id });
				params.push("can_do_kinds=" + `${kind_ids.join(',')}`);
			}

			if (params.length > 0) {
				url+= "?" + params.join('&');
			}

			await axios
				.get(url, {
					"Authorization": "Bearer " + this.$store.state.token,
					"Accept": "application/json"				
				})
				.then((val) => {
					const { status, data, reason } = val.data;

					if (status == "OK") {
						const employee_list_filter = data[0].employees.filter(e => { return e.is_employee === true });
						const employee_list = JSON.parse(JSON.stringify(employee_list_filter));
						employee_list.forEach(e => {
							e['id'] = `${ALLEMPLOYEES}_${e.id}`;
							e['type'] = ALLEMPLOYEES;
							e['tooltip'] = Employee_Key;
						});

						const freelancer_list_filter = data[0].employees.filter(e => { return e.is_feelancer === true && e.is_employee === false });
						const freelancer_list = JSON.parse(JSON.stringify(freelancer_list_filter));
						freelancer_list.forEach(e => {
							e['id'] = `${FREELANCER}_${e.id}`;
							e['type'] = FREELANCER;
							e['tooltip'] = Freelancer_key;
						});

						const roles_list = JSON.parse(JSON.stringify(data[0].roles));
						roles_list.forEach(e => {
							e['id'] = `${ROLES}_${e.id}`;
							e['type'] = ROLES;
							e['tooltip'] = 'Role';
						});

						const departments_list = JSON.parse(JSON.stringify(data[0].departments));
						departments_list.forEach(e => {
							e['id'] = `${DEPARTMENTS}_${e.id}`;
							e['type'] = DEPARTMENTS;
							e['tooltip'] = 'Department';
						});

						const list = [...employee_list, ...freelancer_list, ...roles_list, ...departments_list];
						this.invitees = this._getAllAssigned(list);


						let employees = [];
						if (data[0].employees && data[0].employees.length !== 0) {
							const employe_filter = data[0].employees.filter(e => { return e.is_employee === true });
							employees = this._getAllEmployees(employe_filter);
						}

						let freelancers = [];
						if (data[0].employees && data[0].employees.length !== 0) {
							const freelancer_filter = data[0].employees.filter(e => { return e.is_feelancer === true && e.is_employee === false });
							freelancers = this._getFreelancers(freelancer_filter);
						}

						let roles = [];
						if (data[0].roles && data[0].roles.length !== 0) {
							roles = this._getRoles(data[0].roles);
						}

						let departments = [];
						if (data[0].departments && data[0].departments.length !== 0) {
							departments = this._getDepartments(data[0].departments);
						}

						this.assign_items.forEach(a => {
							if (a.id === ALLEMPLOYEES) {
								a.children = employees;
							}
							if (a.id === FREELANCER) {
								a.children = freelancers;
							}
							if (a.id === ROLES) {
								a.children = roles;
							}
							if (a.id === DEPARTMENTS) {
								a.children = departments;
							}
						});

						this.assign_items_origin.forEach(a => {
							if (a.id === ALLEMPLOYEES) {
								a.children = employees;
							}
							if (a.id === FREELANCER) {
								a.children = freelancers;
							}
							if (a.id === ROLES) {
								a.children = roles;
							}
							if (a.id === DEPARTMENTS) {
								a.children = departments;
							}
						});

						this.loading = false;
						this.is_open = true;
						this.close_all = false;
					} else {
						this.loading = false;
						this.error_msg = reason;
					}
				})
				.catch((e) => {
					this.loading = false;
					this.error_msg = e.message;
				});
		},
		_getAllAssigned(data) {
			const unique = [];
			const obj_tmp = {};
			data.forEach(d => {
				if (!obj_tmp[d.id]) {
					unique.push(d);
					obj_tmp[d.id] = true;
				}
			});

			const employees_all = [];
			unique.forEach(e => {
				let display_name = this.formatName(e.display_name);

				const obj = {
					id: e.id,
					name: display_name,
					type: e.type,
					kind: e.can_do_kind,
					tooltip: e.tooltip
				};
				
				employees_all.push(obj);
			});

			const employees_kind = employees_all.filter(e => { return e.kind === true });
			employees_kind.sort((a, b) => { 
				const nameA = a.name.toUpperCase()
				const nameB = b.name.toUpperCase();

				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});

			const employees_un_kind = employees_all.filter(e => { return e.kind === false });
			employees_un_kind.sort((a, b) => {
				const nameA = a.name.toUpperCase()
				const nameB = b.name.toUpperCase();

				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});

			return [...employees_kind, ...employees_un_kind];
		},
		_getAllEmployees(data) {
			const unique = [];
			const obj_tmp = {};
			data.forEach(d => {
				if (!obj_tmp[d.id]) {
					unique.push(d);
					obj_tmp[d.id] = true;
				}
			});

			const employees_all = [];
			unique.forEach(e => {
				let display_name = this.formatName(e.display_name);

				const obj = {
					id: `${ALLEMPLOYEES}_${e.id}`,
					name: display_name,
					type: ALLEMPLOYEES,
					kind: e.can_do_kind,
					tooltip: Employee_Key
				};
				
				employees_all.push(obj);
			});

			const employees_kind = employees_all.filter(e => { return e.kind === true });
			employees_kind.sort((a, b) => { 
				const nameA = a.name.toUpperCase()
				const nameB = b.name.toUpperCase();

				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});

			const employees_un_kind = employees_all.filter(e => { return e.kind === false });
			employees_un_kind.sort((a, b) => {
				const nameA = a.name.toUpperCase()
				const nameB = b.name.toUpperCase();

				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});

			return [...employees_kind, ...employees_un_kind];
		},
		_getFreelancers(data) {
			const unique = [];
			const obj_tmp = {};
			data.forEach(d => {
				if (!obj_tmp[d.id]) {
					unique.push(d);
					obj_tmp[d.id] = true;
				}
			});

			const employees_all = [];
			unique.forEach(e => {
				let display_name = this.formatName(e.display_name);

				const obj = {
					id: `${FREELANCER}_${e.id}`,
					name: display_name,
					type: FREELANCER,
					kind: e.can_do_kind,
					tooltip: Freelancer_key
				};
				
				employees_all.push(obj);
			});

			const employees_kind = employees_all.filter(e => { return e.kind === true });
			employees_kind.sort((a, b) => { 
				const nameA = a.name.toUpperCase()
				const nameB = b.name.toUpperCase();

				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});

			const employees_un_kind = employees_all.filter(e => { return e.kind === false });
			employees_un_kind.sort((a, b) => {
				const nameA = a.name.toUpperCase()
				const nameB = b.name.toUpperCase();

				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});

			return [...employees_kind, ...employees_un_kind];
		},
		_getRoles(data) {
			const roles_all = [];
			data.forEach(d => {
				let display_name = this.formatName(d.display_name);
				const obj = {
					id: `${ROLES}_${d.id}`,
					name: display_name,
					type: ROLES,
					kind: d.can_do_kind,
					tooltip: 'Role'
				};
				
				roles_all.push(obj);
			});

			const roles_kind = roles_all.filter(d => { return d.kind === true });
			roles_kind.sort((a, b) => { 
				const nameA = a.name.toUpperCase()
				const nameB = b.name.toUpperCase();

				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});

			const roles_un_kind = roles_all.filter(d => { return d.kind === false });
			roles_un_kind.sort((a, b) => { return a.name.toLowerCase() > b.name.toLowerCase() });
			
			return [...roles_kind, ...roles_un_kind];
		},
		_getDepartments(data) {
			const departments_all = [];
			data.forEach(d => {
				let display_name = this.formatName(d.display_name);
				const obj = {
					id: `${DEPARTMENTS}_${d.id}`,
					name: display_name,
					type: DEPARTMENTS,
					kind: d.can_do_kind,
					tooltip: 'Department'
				};
				
				departments_all.push(obj);
			});

			const departments_kind = departments_all.filter(d => { return d.kind === true });
			departments_kind.sort((a, b) => {
				const nameA = a.name.toUpperCase()
				const nameB = b.name.toUpperCase();

				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});

			const departments_un_kind = departments_all.filter(d => { return d.kind === false });
			departments_un_kind.sort((a, b) => {
				const nameA = a.name.toUpperCase()
				const nameB = b.name.toUpperCase();

				if (nameA < nameB) {
					return -1;
				}
				if (nameA > nameB) {
					return 1;
				}
				return 0;
			});
			
			return [...departments_kind, ...departments_un_kind];
		},
		formatName(name) {
			let display_name = '';
			if (name.includes(',')) {
				const name_arr = name.split(',');
				if (name_arr[1].includes('(')) {
					const name_tmp = name_arr[1];
					const index = name_tmp.indexOf('(');
					const first_name = name_tmp.substring(0, index-1).trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name} ${name_tmp.substring(index, name_tmp.length)}`;
				} else {
					const first_name = name_arr[1].trim();
					const last_name = name_arr[0].trim();
					display_name = `${first_name} ${last_name}`;
				}
			} else {
				display_name = name;
			}

			return display_name;
		},
		filter(queryText) {			
			if (queryText) {
				this.open = [];
				const searchText = queryText.toLowerCase();
				const assign_items_tmp = [];

				this.assign_items.forEach(a => {
					const children_tmp = a.children.filter(a => {
						const name = a.name.toLowerCase();
						return name.includes(searchText);
					});
					a.children = children_tmp;

					if (children_tmp.length > 0) {
						assign_items_tmp.push(a);
						this.open.push(a);
					}
				});

				this.assign_items = [];
				this.assign_items = assign_items_tmp;
			} else {
				this.assign_items = [];
				this.assign_items_origin.forEach(a => {
					const children_temp = [];
					a.children.forEach(c => {
						children_temp.push(c);
					});
					const obj = {
						id: a.id,
						name: a.name,
						children: children_temp
					};
					this.assign_items.push(obj);
				})
				
				this.assigned_to = [];
				this.invitees_to = [];
			}
		},
		onInviteesToChange(event) {
			this.assigned_to = this.invitees.filter(i => { return event.includes(i.id) });
		},
		onTreeviewNoteActive(notes) {
			this.assigned_to = [];
			this.assigned_to = notes;
			this.invitees_to = this.assigned_to.map(a => { return a.id });
			this.search_key = '';
		},
		remove(item) {
			this.invitees_to = this.invitees_to.filter(a => { return a !== item.id });
			this.assigned_to = this.assigned_to.filter(a => { return a.id !== item.id });
		}
	}
}
</script>
<style lang="scss" scoped>
.tree-container {
	position: fixed;
	z-index: 12;
	background-color: #FFFFFF;
	box-shadow: 0px 1px 1px #192A3E;

	height: 240px;
	overflow-y: auto;
}
.tree-wrap {
	overflow: auto;
}
.tree-wrap-container {
  height: 99%;
}
.load {
	border: 2px solid #C4C4C4;
  border-top: 2px solid #192A3E;
	border-right: 2px solid #192A3E;
  border-radius: 50%;
  width: 20px;
  height: 20px;
	animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

::v-deep {
  .v-treeview-node__level {
    width: 24px;
  }
  .v-treeview-node__checkbox {
    margin-left: 0 !important;
  }
  .v-treeview--dense .v-treeview-node__root {
    min-height: 32px;
  }
}
</style>